import React from "react";
import { useSimulation } from "@/context/SimulationContext";
import { useI18n } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, Award } from "lucide-react";

export default function PhaseFooter({
  onNext,
  onBack,
  nextLabel,
  backLabel,
  nextDisabled = false,
  nextTestId = "next-phase-btn",
  backTestId = "back-phase-btn",
  isFinal = false,
}) {
  const { phase, next, back } = useSimulation();
  const { t } = useI18n();

  const handleNext = () => {
    if (onNext) onNext();
    else next();
  };
  const handleBack = () => {
    if (onBack) onBack();
    else back();
  };

  return (
    <div className="wizard-footer-anchor pt-2 lg:pt-3 flex items-center justify-between gap-4 no-print">
      {phase > 1 ? (
        <Button
          onClick={handleBack}
          variant="ghost"
          data-testid={backTestId}
          className="text-[color:var(--text)] hover:bg-[color:var(--surface-2)] hover:text-[color:var(--text)] border border-[color:var(--border)] hover:border-[color:var(--border-strong)] h-10 px-4 rounded"
        >
          <ChevronLeft className="w-4 h-4 mr-1" />
          {backLabel || t("common.back")}
        </Button>
      ) : (
        <span />
      )}

      <Button
        onClick={handleNext}
        disabled={nextDisabled}
        data-testid={nextTestId}
        className="bg-[color:var(--brand)] hover:bg-[color:var(--brand-dim)] text-black font-semibold h-10 px-5 rounded transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      >
        {isFinal && <Award className="w-4 h-4 mr-2" />}
        {nextLabel || (phase === 4 ? t("common.finish") : t("common.next"))}
        {!isFinal && <ChevronRight className="w-4 h-4 ml-1" />}
      </Button>
    </div>
  );
}
